<template>
    <div>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <h2>Detalhar Atividade</h2>
          </v-card-title>
          <v-card-text>
            <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" style="color: white;" class="mb-3">
              <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
              <div v-if="msgArrayError.length > 0">
                <ul v-for="error of msgArrayError" :key="error.key">
                  <li>{{ error }}</li>
                </ul>
              </div>
            </v-alert>
            <form @submit.prevent="onSubmit">
              <div>
                  <Input style="width: 100%" type="text" label="Código" v-model="form.identificadordetalharatividade" disabled />
                  <Input style="width: 100%" type="text" label="Descrição" v-model.trim="form.descricaodetalhada" :v="$v.form.descricaodetalhada" />
                  <Input style="width: 100%" type="number" step="0.01" label="Valor" v-model.number="form.valornotadetalhada" :v="$v.form.valornotadetalhada" />
              </div>
              <div id="btn-acoes-b">
                <v-btn class="rounded-sm font-weight-regular me-4" type="submit" color="teal"  small :loading="loading" dark>Salvar</v-btn>
                <v-btn class="rounded-sm font-weight-regular me-4" type="button" small :disabled="acaoForm != 'editar' || loading" color="error" @click="excluir">Excluir</v-btn>
                <v-btn class="rounded-sm font-weight-regular" type="button" small :disabled="loading" @click="fecharDialog">Cancelar</v-btn>
              </div>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
import Input from '@/components/Input';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import {
  required, maxLength, minLength, alpha, integer, minValue, maxValue, decimal
} from 'vuelidate/lib/validators';
const DARepository = RepositoryFactory.get('detalharAtividade');

const setFormInicial = () => ({
  descricaodetalhada:'',
  valornotadetalhada:'',
  identificadordetalharatividade: '',
  aaletivo: '',
  cdtipesc: '',
  cdescola: '',
  cdturma: '',
  cddiscipl: '',
  identificadordistribuirnotas: '',
});

export default {
  name: 'detalhar-atividade',
  components: {
    Input,
  },
  props: {
    acao: String,
    identificadordetalharatividade: {
      type: [String, Number],
      default: null,
    },
    aaletivo:{
      type: [String, Number],
      default: null,
    },
    cdtipesc:{
      type: [String, Number],
      default: null,
    },
    cdescola:{
      type: [String, Number],
      default: null,
    },
    cdturma:{
      type: String,
      default: null,
    },
    cddiscipl:{
      type: [String, Number],
      default: null,
    },
    identificadordistribuirnotas:{
      type: Number,
      default: null,
    },
    dialog:{
      type: Boolean,
      default: false,
    },
    retorno: Function,
  },
  data() {
    return{
      loading: false,
      acaoForm: 'novo',
      form: setFormInicial(),
      formUltimo: {},
      msgArrayError: [],
      maxValue: null,
    };
  },
  validations: {
    form: {
      descricaodetalhada: {
        required, maxLength: maxLength(100), minLength: minLength(4),
      },
      valornotadetalhada: {
        required,
        decimal,
        maxValue (value){
          return maxValue(this.maxValue)(value)
        },
      },
    },
  },
  methods: {
    fecharDialog(){
      this.msgArrayError = [];
      this.$emit('update:dialog', false)
      //this.form = setFormInicial();
    },
    async returnDialog(data){
      this.$emit('retorno');
    },
    async valorMaximo(){
      const { data } = await DARepository.getMaxValueDetalharAtividade(this.form);
      this.maxValue = data.results.disponivel;
    },
    async onSubmit(){
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      try{
        const funcao = (this.acaoForm === 'novo') ? 'post' : 'put';

        const { data } = await DARepository[`${funcao}DetalharAtividade`](this.form);

        this.submitText = data.message;
        this.msgArrayError = [];
        this.form = { ...data.results };
        //this.acaoForm = 'editar';
        //await this.returnDialog(data);
        this.$emit('retorno');
        this.$Progress.start();
        this.fecharDialog();

      }catch(error){
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      }
      this.$v.$reset();
      //this.$Progress.finish();
      this.loading = false;
    },
    async excluir(){
      this.loading = true;
      try {
        // this.$Progress.start();
        const { data } = await DARepository.deleteDetalharAtividade({identificadordetalharatividade: this.form.identificadordetalharatividade});

        this.submitText = data.message;
        this.msgArrayError = [];
        this.returnDialog(data);
        this.fecharDialog();
        this.$emit('retorno');
      } catch (error) {
        this.loading = false;
        const ntfExcluir = await this.$sgal({
          title: 'Não foi possível!',
          text: error.response.data.errorMessage[0],
          type: 'notification',
        });
      }
      // this.$Progress.finish();
      this.loading = false;
    },
    async buscar(id) {
      this.loading = true;
      try{
        this.$Progress.start();
        const response = await DARepository.getDetalharAtividade({identificadordetalharatividade: id, take: 1});
        if(response.data.results[0]){
          //console.log(response);
          this.form = response.data.results[0];
          this.valorMaximo();
        }else
          return 'error'
      }catch(error){
        console.log(error)
      }
      this.$Progress.finish();
      this.loading = false;
    },
    abrirModal(data) {
      this.form = setFormInicial();
      this.$v.$reset();
      this.acaoForm = data.acao;
      this.msgArrayError = [];
      if(data.acao === 'novo') {
        this.form = { ...data };
        this.valorMaximo();
      }else
      if(data.acao === 'editar') {
        this.form.identificadordetalharatividade = data.identificadordetalharatividade;
        this.buscar(data.identificadordetalharatividade);
      }
    }
  },
}
</script>
<style scoped lang="scss">
  #btn-acoes-b {
    position: relative;
    width: 100%;
    border-radius: 0px;
    text-align: right;
  }
</style>
